module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("MAPS, ILLUSTRATIONS, DIAGRAMS AND PHOTOGRAPHS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("A")]), _vm._v("lthough this book is primarily concerned with some 400 route miles of the Great Central Railway and its associated railways, it necessarily makes reference to other routes. That, plus a need for reference to a multitude of junctions that were used to direct traffic flows, will make it worthwhile for many readers to be able to make reference to a wide selection of maps. The maps are supplemented by some illustrations relevant to significant events along the way and also by diagrams to show the scale of operations involved. For the photographs, I have opted to include a wide range depicting developments throughout the period covered by the book; selection of that option allowed greater use of colour to support the monochrome images. Unless otherwise credited the photographs were taken by the author. Photographs on and about the track at heritage railways were taken with authorisation and regard to safety. The selection was taken from an archive that has evolved over several decades and it should not be assumed that a particular subject will still be operational at the same railway today")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-766d896c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_List.vue
// module id = 72
// module chunks = 0